import BaseService from "./base.service";
import { Singleton } from "util";
import { ApiResourceBuilder } from "core/builder";

@Singleton
export default class CashRegisterService extends BaseService {
  async fetch(companyUuid, { order, pagination, filters, transforms }) {
    const url = `/v1/companies/${companyUuid}/cash_register_reports`;
    const resourceRoute = ApiResourceBuilder.buildFromParams(url, {
      order,
      pagination,
      filters,
      transforms
    });
    return await this.get(resourceRoute);
  }

  async getDocument(uuid) {
    const url = `/v1/cash_register_reports/${uuid}/transactions_pdf`;
    return await this.get(url, { responseType: "arraybuffer" });
  }
  async getFile(uuid) {
    const url = `/v1/cash_register_reports/${uuid}/file`;
    return await this.get(url, { responseType: "arraybuffer" });
  }
}



// WEBPACK FOOTER //
// ./src/core/service/cash-register.service.js